/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filter_ArchivedInputs */

const en_filter_archived = /** @type {(inputs: Filter_ArchivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archived`)
};

/**
* | output |
* | --- |
* | "Archived" |
*
* @param {Filter_ArchivedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const filter_archived = /** @type {((inputs?: Filter_ArchivedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filter_ArchivedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_filter_archived(inputs)
});